import { useQuery, } from "@tanstack/react-query";
import { useFlag, } from "@unleash/proxy-client-react";

import { MainPageView, } from "./MainPageView.tsx";
import { operationsQueryConfig, } from "../../../api";

export function MainPageDefault() {
  // if the response from this hook is empty, we show the empty state.
  // this request is not implemented yet.
  // const paymentsData = useQuery(repaymentSchedulesQueryConfig(),);
  const operations = useQuery(operationsQueryConfig(),);
  const paymentsData = operations.data?.data ?? [];
  const isOperationsHistoryEnabled = useFlag("operations.history",);
  // const isPaymentCardsEnabled = useFlag("payments.cards",);
  // const isNextPaymentsEnabled = useFlag("payments.next_payments_block",);

  return (
    <MainPageView
      payments={{
        isSuccess: operations.isSuccess,
        count: paymentsData.length,
      }}
      isOperationsHistoryEnabled={isOperationsHistoryEnabled}
    />
  );
}
